import { useState, useCallback } from 'react';
import { getVisitorCurrencyRate } from '../utils/getVisitorInfo';
import { useAppSelector } from './useRedux';

export default function useCurrency() {
  const { currency: defaultCurrency, countryCode: defaultCountryCode } = useAppSelector(
    (state) => state.visitorInfoSlice
  );
  const { userData } = useAppSelector((state) => state.userSlice);

  let currency = userData?.preference?.currency || defaultCurrency;
  const [rate, setRate] = useState(0);

  const exchangedRate = useCallback(async () => {
    getVisitorCurrencyRate(currency.code).then((value) => {
      setRate(value);
    });
  }, [userData?.preference?.currency]);
  exchangedRate();

  const locale = `en-${defaultCountryCode}`;
  const options = {
    style: 'currency',
    currency: currency.code
  };
  const formatter = new Intl.NumberFormat(locale, options);

  const currencyFormatter = (value: number) => {
    return formatter.format(value);
  };

  return (price: number) => {
    let exchangedPrice = Number((rate * price).toFixed(2));
    return { amountString: currencyFormatter(exchangedPrice), amount: exchangedPrice };
  };
}
